import { Pipe, PipeTransform } from '@angular/core';

import { IStatistics } from '../../interfaces/statistics.interface';

@Pipe({
  name: 'statisticsSum',
  standalone: true,
})
export class StatisticsSumPipe implements PipeTransform {
  public transform(fieldName: string, statistics: IStatistics[] | Record<string, IStatistics>): number {
    if (!fieldName || !statistics) return 0;

    const values = Object.values(statistics).filter((stat) => stat != null); // Filter out null/undefined values
    if (values.length === 0) return 0;

    return values.reduce((prev, curr) => {
      const value = curr?.[fieldName];
      return prev + (typeof value === 'number' && !Number.isNaN(value) ? value : 0);
    }, 0);
  }
}
